export const Footer = () => {
    return (
        <footer>

            <div className="ourlocation">
                <div className="container">
                    <p><i>Disclaimer :- We are independent third-party Service Provider &amp; We are independent customer service providers &amp; and are not affiliated with any third-party brands, trademarks, logos, or products mentioned. We do not use any brand names for promotional purposes but solely for informative reference. All third-party trademarks, logos, brand names, products, and services are the property of their respective owners.</i></p>
                    <p><i>Our services are available across all locations in Muzaffarpur.</i></p>
                    <a href="/">Home</a> | 
                    <a href="privacypolicy"> Privacy Policy</a>
                </div>
            </div>

            <div className="fix-phone">
                <p><a href="tel:8271463038 ">Home Visit Call : +91-8271463038 </a></p>
            </div>
        </footer>
    )
}